module.exports = __webpack_public_path__ + "static/img/writingjapaneseanimal_17_optimized.28ab29e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/thumbnail/writingjapaneseanimal_17_optimized.jpg
// module id = M4GN
// module chunks = 0